module.exports = __webpack_public_path__ + "static/media/mx.fc563797.svg";